import React from 'react';
import './AppSeparator.css';

export default function AppSeparator() {
  return (
    <div className="app-separator pt-3 pb-3">
      <hr />
    </div>
  );
}
